export default __webpack_public_path__ + "da29992a8657fc69cff200d94c197196.gif";